<template>
    <div class="article">
      <van-nav-bar
        title="文章管理"
        left-text="返回"

        left-arrow
        @click-left="onClickLeft"
      />

          <ul class="cate-list">
            <li :class="{cateselected:currentCateIndex==-1?true:false}" @click="clickCate(-1)">全部</li>
            <li :class="{cateselected:currentCateIndex==index?true:false}" v-for="(cate,index) in categoryList" @click="clickCate(index,cate.cate_id)">{{cate.cate_name}}</li>
          </ul>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad" class="content-list" id="contentList"
          >
            <div v-for="(product,productIndex) in tabContent" :key="productIndex" class="article-list">
              <div class="card-title">{{product.goods_name}}</div>
              <div class="footer">
                <i class="iconfont icon-caidan" @click="onClickMenu($event,product.goods_id)"></i>
                <div class="menu">
                  <ul>
                    <li><a :href="'#/mobile/product/create?productId='+product.goods_id"><i class="iconfont icon-editor"></i>编辑</a></li>
                    <li v-if="product.status == 1"><a href="javascript:;" @click="productDown(product.goods_id,productIndex)"><i class="iconfont icon-xiazaidaoru"></i>下架</a></li>
                    <li v-else><a href="javascript:;" @click="productUp(product.goods_id,productIndex)"><i class="iconfont icon-shangchuandaochu"></i>上架</a></li>
                    <li><a href="javascript:;" @click="handleDelete(product.goods_id)"><i class="iconfont icon-lajixiang"></i>删除</a></li>
                    <li><a href="javascript:;"><i class="iconfont icon-fenxiang"></i>推广</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </van-list>

      <van-tabbar v-model="active">
        <van-tabbar-item to="/mobile/article/create">添加文章</van-tabbar-item>
        <van-tabbar-item to="/mobile/nav/index">栏目管理</van-tabbar-item>
      </van-tabbar>
    </div>
</template>

<script>
    import {NavBar,Cell,CellGroup,Icon,Dialog,List,Card,Tabs,Tab,Tabbar,TabbarItem} from 'vant'
    import Cookies from 'js-cookie'
    export default {
        name: "index",
        components:{
            [NavBar.name]:NavBar,
            [Cell.name]:Cell,
            [CellGroup.name]:CellGroup,
            [Icon.name]:Icon,
            [Dialog.name]:Dialog,
            [List.name]:List,
            [Card.name]:Card,
            [Tabs.name]:Tabs,
            [Tab.name]:Tab,
            [Tabbar.name]:Tabbar,
            [TabbarItem.name]:TabbarItem
        },
        data(){
            return {
                list:[],
                active:0,
                tabList:[],
                categoryList:[],
                currentCateIndex:0,
                loading:false,
                finished:false,
                tabContent:[]
            }
        },
        created() {
            this.$http.get(this.apiUrl+'/v1/nav/index',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                this.list = data.result;
                for (var i = 0;i<data.result.length;i++){
                    if (data.result[i].module_id == 1){
                      this.categoryList.push({cate_name:data.result[i].title,cate_id:data.result[i].nav_id})
                    }
                }
                //console.log(this.categoryList)
            })
        },
        methods:{
            onClickLeft(){
                this.$router.back();
            },
            onClickRight(){
                this.$router.push('/mobile/nav/edit')
            },
            clickEdit(navId){
                this.$router.push('/mobile/nav/edit?id='+navId)
            },
            clickDelete(navId){
                this.$http.delete(this.apiUrl+'/v1/nav/delete',{params:{navId:navId}}).then(({data})=>{
                    Dialog.alert({
                        message:data.msg
                    }).then(()=>{
                        this.$http.get(this.apiUrl+'/v1/nav/index').then(({data})=>{
                            this.list = data.result;
                        })
                    })
                })
            },
            getContent(index,title){
                this.currentIndex = 0;
                var if_show = 1,
                    _this = this;
                if (index == 0){
                    if_show = 1
                }else{
                    if_show = 0
                }
                this.$http.get('/v1/nav/index',{params:{siteId:Cookies.get('siteId')}}).then((res)=>{
                    this.tabContent = res.data
                })
            },
            onLoad(){
                this.loading = true;
                this.$http.get('/v1/product/list',{params:{cate_id:this.cate_id}}).then(({data})=>{
                    this.tabContent = data.productList;
                    if (data.productList.length < 10){
                        this.loading = false;
                        this.finished = true;
                    }
                })
            },
            clickCate(index,cateId){
                this.currentCateIndex = index;
                let status;
                if (this.active == 0) {
                    status = 1;
                }else {
                    status = 0
                }
                this.$http.get('/v1/product/list',{params:{cate_id:cateId,status:status}}).then(({data})=>{
                    this.tabContent = data.productList;
                    if (data.productList.length < 10){
                        this.loading = false;
                        this.finished = true;
                    }
                })
            }
        }
    }
</script>

<style scoped>
  .tabs{
    padding-bottom: 60px;
  }
  .card-price{
    color: #ff6100;
    font-size: 14px;
  }
  .card-title{
    width:100%;
    font-size: 14px;
    height:45px;
    overflow: hidden;
    border-bottom: 1px dashed #c5c5c5;
  }

  .card-footer li{
    float: left;
    font-size: 12px;
  }
  .card-stock{
    color: #5c5c5c;
    font-size: 12px;
  }
  .icon-caidan{
    font-size: 24px;
    position: absolute;
    right: 0px;
    bottom: -10px;
  }
  .menu{
    background: #4a4a4a;
    overflow: hidden;
    padding: 10px 20px;
    display: none;
    min-width: 260px;
    position: absolute;
    /* left: 0; */
    right: 0;
    text-align: center;
    z-index: 999;
  }
  .menu li{
    float: left;
    width: 60px;
    text-align: center;
  }
  .menu li a{
    font-size: 14px;
    color: #fff;
  }
  .menu-active{
    display: block;
  }
  .van-card, .van-card__row, .van-card__thumb{
    display: block;
  }
  .van-card >>> .van-card__footer{
    position: relative;
    right: 0;
    bottom: 0;
  }
  .cate-list{
    width:25%;
    float: left;
    height:100%;
    background: #f9f9f9;
  }
  .cate-list li{
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
  .content-list{
    float: right;
    width: 75%;
  }
  .cateselected{
    background: #f44;
    color: #fff;
  }
  .tabs-content{
    margin:10px 0 0 0;
  }
  .van-card__thumb img{
    height: 90px;
  }
  .article-list{
    line-height: 45px;
    padding:0 10px;

  }
  .article{
    height: 100%;
  }
</style>
